import { render } from "./DocumentMinusIcon.vue?vue&type=template&id=d1bdf08c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__